/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, { Component } from 'react';
import LegalContent from './LegalContent';

class Footer extends Component {
    render() {
        let legalContent = <LegalContent {...this.props}/>;
        return (
            <section className="footer">
                <div className="container clearfix">  
                    <div>
                        <p>
                            <b>For Financial Professional Use Only/Not for distribution to the public.</b>
                        </p>
                        <p>
                            This material has been prepared for educational purposes only and is not intended
                            as a personalized recommendation or fiduciary advice. It is not intended to provide, 
                            and should not be relied upon for, investment, accounting, legal, or tax advice. 
                        </p>
                        <p className="mt-2">
                            &copy;2020 American Century Proprietary Holdings, Inc. All rights reserved.                                                                                  
                        </p>
                    </div> 
                    <div>                  
                        {this.props.debug ? 
                            <a onClick={() => {
                                this.props.showReport();
                            }}>Show Report</a>  
                        : null }                  
                        <a onClick={() => {
                            this.props.showModal('Target-Date Fund Additional Information', legalContent, 'modal-full');
                        }}>Required Fund Disclosure</a>                 
                    </div>   
                </div>
            </section>
        );
    }
}

export default Footer;
